(() => {
  const PRODUCT_HANDLE = 'vrdhaan';

  function groupPurchaseButtons(root = document) {
    const productForm = root.querySelector(
      `.product-form[data-product-handle="${PRODUCT_HANDLE}"]`
    );
    const amazonButton = root.querySelector('a.hm-amazon-btn');

    if (!productForm || !amazonButton) return;

    const purchaseRow = productForm.querySelector('.product-form__actions > .flex');
    const amazonBlock = amazonButton.closest('.main-product__block-custom_liquid');

    if (!purchaseRow || !amazonBlock) return;

    purchaseRow.classList.add('hm-vardaan-purchase-row');
    amazonBlock.classList.add('hm-vardaan-amazon-purchase');

    if (amazonBlock.parentElement !== purchaseRow) {
      purchaseRow.append(amazonBlock);
    }

    const amazonLogo = amazonButton.querySelector('img');
    if (amazonLogo) {
      amazonLogo.decoding = 'async';
      amazonLogo.loading = 'lazy';
    }
  }

  groupPurchaseButtons();
  document.addEventListener('shopify:section:load', (event) => {
    groupPurchaseButtons(event.target);
  });
})();
